module.exports = __webpack_public_path__ + "img/thumbnail_MalayanTapir_m_normal.f5525739.png";